export interface SearchListIconCellData {
  type: 'ICON';
  icon: string;
  style?: { [key: string]: string };
  cssClass?: string;
}

export interface PersonenSucheStatusCell extends SearchListIconCellData {
  suchStatus: PersonenSucheStatus;
}

export enum PersonenSucheStatus {
  UNVOLLSTAENDIG,
  INVALID,
  OK,
}

export enum PersonenSucheStatusColor {
  UNVOLLSTAENDIG = '#efbe25',
  INVALID = '#dc3149',
}
